module.exports = __webpack_public_path__ + "img/license_image0.7cc76507.png";